module.exports = __webpack_public_path__ + "img/icon1.ef514def.png";